import { FC, ReactNode } from 'react';
import { Section } from '@jbc-year-end-adj/2024/components/ui/Section';

import { Lead } from './parts/Lead';
import { Content } from './parts/Content';

type FinishProps = {
  children: ReactNode;
};

export const Finish: FC<FinishProps> = ({ children }) => {
  return (
    <Section>
      <Section.Header>年末調整終了</Section.Header>

      <Section.Body>
        <Content>
          <Lead>回答を提出します</Lead>
          {children}
        </Content>
      </Section.Body>
    </Section>
  );
};
